export const MY_PRIZES_VALUES = [
  {
    value: 'R$ 1000,00',
    is_big_gain: true,
  },
  {
    value: 'R$ 10,00',
    is_big_gain: false,
  },
  {
    value: '5 números',
    is_big_gain: false,
  },
  {
    value: 'R$ 50,00',
    is_big_gain: false,
  },
  { value: 'R$ 500,00', is_big_gain: false },
  {
    value: '5 números',
    is_big_gain: false,
  },
  {
    value: 'R$ 50,00',
    is_big_gain: false,
  },
  { value: 'R$ 500,00', is_big_gain: false },
  {
    value: '5 números',
    is_big_gain: false,
  },
  {
    value: 'R$ 50,00',
    is_big_gain: false,
  },
  { value: 'R$ 500,00', is_big_gain: false },
];
